// The screen's aggregator: every opening variation and colour of the last 30
// days, ranked by the score after the opening (`openingsRanking`; results do
// not count). Registered with the game store by this plugin's setup; the
// store runs it over the last 30 days.
import { openingsRanking, type OpeningsRanking } from '@chess/api-insights';
import { aggregatorId, collect, type Accumulator, type Aggregator } from '@chess/api-model';

export class RankingAggregator implements Aggregator<OpeningsRanking> {
  readonly id = aggregatorId('openings-ranking');

  start(): Accumulator<OpeningsRanking> {
    return collect(openingsRanking);
  }
}
